import { render, staticRenderFns } from "./Outstandings_Summary_Customer.vue?vue&type=template&id=64060520&scoped=true&"
import script from "./Outstandings_Summary_Customer.vue?vue&type=script&lang=js&"
export * from "./Outstandings_Summary_Customer.vue?vue&type=script&lang=js&"
import style0 from "./Outstandings_Summary_Customer.vue?vue&type=style&index=0&id=64060520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64060520",
  null
  
)

export default component.exports